// extracted by mini-css-extract-plugin
export var standaloneTable = "_f4-0";
export var standaloneTableWithBodyFill = "_f4-1";
export var withExtraHeader = "_f4-2";